import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import get from 'lodash/get';
import each from 'lodash/each';
import isEqual from 'lodash/isEqual';
import Bem from 'bemHelper';
import numDesc from 'helpers/numDesc';
import { emit } from 'helpers/global-events';
import { I18nHoc } from 'helpers/i18n';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import { UserProp } from 'auth';
import { Checkbox } from 'containers/form';
import Paginator, { Control, Container, Pages } from 'components/paginator';
import Row, { Col } from 'components/row';
import { Thumb } from 'components/image';
import { ModalButton, Header, Content, Footer } from 'components/modal';
import Notification from 'components/notification';
import Button, { btnViews } from 'components/button';
import Icon, { iconTypes } from 'components/icon';
import { AccordionBlock } from 'components/accordion';

import UsersShow from './users-show';
import AwardUserButton from '../award-user-button';
import AddForumNick from '../add-forum-nick';

import translates from './vote-i18n';

import 'styles/forum/common/voting/_vote.scss';
import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';

const bemClassesVote = new Bem('voteItem');
const bemClassesAdminPane = new Bem('adminPanelForum');

// Show vote.
@apiDecorator
@I18nHoc(translates())
export default class Vote extends Component {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    auth: UserProp,
    forumType: PropTypes.string
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.vote = this.vote.bind(this);
    this.onAnswerChange = this.onAnswerChange.bind(this);
    this.fillCheckboxesData = this.fillCheckboxesData.bind(this);

    this.state = {
      answers: {},
      needForumNick: false
    };
  }

  componentWillMount() {
    this.fillCheckboxesData(this.props, true);
  }

  componentDidUpdate() {
    this.fillCheckboxesData(this.props);
  }

  showMaxAnswersAmount = (item = {}) => {
    const { i18n } = this;
    if (item.settings && item.settings.allow_amount_answers) {
      return (
        <span {...bemClassesVote('text')}>
          {`${i18n('canSelect')} ${numDesc(item.settings.allow_amount_answers, i18n('answer1'), i18n('answer2'), i18n('answer3'))}.`}&nbsp;
        </span>
      );
    }

    return null;
  }

  // Add or remove answer from answers array.
  onAnswerChange(checked, qid, aid) {
    const answers = { ...this.state.answers };
    const allowAmountAnswers = get(this, 'props.data[0].settings.allow_amount_answers', 1);

    if (!answers[qid] || allowAmountAnswers === 1) answers[qid] = [];

    if (checked) {
      answers[qid].push(aid);
    } else {
      answers[qid].splice(answers[qid].indexOf(aid), 1);
    }

    this.setState({ answers });
  }

  // Fill checkboxes values from DB if exist.
  fillCheckboxesData({ auth: { authenticated } = {}, data = [] }, firstMount = false) {
    if (authenticated && (firstMount || !isEqual(this.props.data, data))) {
      const answers = { ...this.state.answers };

      each(data, ({ counter = {}, qid }) => {
        const users = counter.users || {};

        if (users && users[qid]) answers[qid] = [];
        if (users[qid] && users[qid].length > 0) {
          return answers[qid] = [...users[qid]];
        }
      });

      this.setState({ answers });
    }
  }

  // Call after success vote.
  afterVote() {
    Notification.success('Спасибо. Ваш голос учтен.');

    // Make reload data provider for Vote.
    emit('updateVote');

    return true;
  }

  // Send array with votes to backend.
  vote(qid, answers = null) {
    if (!answers || !answers.length) {
      return Notification.error('Выберите варианты ответов');
    }

    this.api.post('action/forum/actions-question/vote-get', {
      postData: {
        qid,
        answers
      }
    })
      .then(() => this.afterVote())
      .catch(error => reportError(error));
  }

  // Check exist user vote for this answer.
  checkMyVote(answer = {}, userId = null, item = {}) {
    return (
      userId && item.counter && item.counter.users &&
      item.counter.users[item.qid] && item.counter.users[item.qid].includes(answer.aid)
    );
  }

  // Show percents for answers.
  countVotes(key, counter) { // eslint-disable-line
    let style = null;
    if (counter.percents && counter.percents[key]) {
      style = { width: `${counter.percents[key]}%` };
    }

    return (
      <div {...bemClassesVote('progressLine')}>
        <span
          {...bemClassesVote('progressingLine')}
          style={style}
        />
      </div>
    );
  }

  setPercentageInfo(info) {
    return (
      <span {...bemClassesVote('progressUser')}>
        <span {...bemClassesVote('text')} children={info || null} />
      </span>
    );
  }

  // Show count users who clicked on an answer.
  countUsers(counter, question = {}, answer = {}) {
    const showAnsweredUsers = get(question, 'settings.allow_answered_users') || question.allRules;
    const aid = get(answer, 'aid');
    const count_by_answer = get(counter,`count_by_answer[${aid}]`, 0);
    const percents = get(counter,`percents[${aid}]`, 0);
    const percentageText = `${count_by_answer}/${percents}%`;

    if (count_by_answer && showAnsweredUsers) {
      const myVote = this.state.answers[question.qid] &&
        this.state.answers[question.qid].includes(answer.aid);

      return (
        <>
          <ModalButton
            {...bemClassesVote('btnPersons', { myVote })}
            buttonProps={{
              iconType: iconTypes.persons,
              title: 'Кто голосовал',
              dataView: btnViews.persons
            }}
            classNameModal={bemClassesAdminPane('modal', 'persons').className}
            size="big"
          >
            <Header closeButton children={answer.answer} />
            <Content>
              <div>
                <Paginator
                  url="forum/users-vote"
                  query={{ aid: answer.aid }}
                  queryJson
                  limit={16}
                >
                  <Control />
                  <Container {...bemClassesVote('paginator')} injectPropName="data">
                    <UsersShow />
                  </Container>
                  <Pages />
                </Paginator>
              </div>
            </Content>
            <Footer>
              <div>
                {question.allRules &&
                  <AwardUserButton answer_id={answer.aid} medal_id={answer.medal_id} />
                }
              </div>
            </Footer>
          </ModalButton>
          {this.setPercentageInfo(percentageText)}
        </>
      );
    }

    return (
      <>
        <Button
          {...bemClassesVote('btnPersons', 'disabled')}
          iconType={iconTypes.persons}
          dataView={btnViews.persons}
        />
        {this.setPercentageInfo(percentageText)}
      </>
    );
  }

  needLogin=()=> {
    if (typeof this.props.actionDoLogin === 'function') this.props.actionDoLogin();
  }

  // Show checkbox with need status.
  showCheckbox(userId, item = {}, myVoteStatus, answer = {}, allowActions) {
    const { answers } = this.state;
    // Check settings for max select answers. By default = 1;
    const allowAmountAnswers = item.settings.allow_amount_answers || 1;
    const answersLength = (answers[item.qid] && answers[item.qid].length) || 0;
    // Get status for checkbox.
    const checked = answers[item.qid] && answers[item.qid].includes(answer.aid);

    const { voteIsOpen = true } = item;
    const checkBoxProps = {
      value: checked,
      disabled: !checked && allowAmountAnswers === answersLength && allowAmountAnswers > 1
    };

    if (!userId) {
      return (
        <div {...bemClassesVote('checkbox', 'withIcon', 'checkbox checkbox_withIcon')}>
          <Button
            {...bemClassesVote('label', null, 'checkbox__label')}
            onClick={this.needLogin}
            customRenderer
          >
            <span {...bemClassesVote('labelContent')}>
              <Icon
                {...bemClassesVote('icon', 'checkbox', 'checkbox__icon_checkbox')}
                type={iconTypes.checkbox}
              />
              <span {...bemClassesVote('text', null, 'checkbox__text checkbox__text_checkbox')} children={answer.answer} />
            </span>
          </Button>
        </div>
      )
    }

    if (!voteIsOpen) {
      return (
        <div {...bemClassesVote('checkbox', 'rewards', 'checkbox_withIcon')}>
          <span {...bemClassesVote('label', null, 'checkbox__label')}>
            {answer.medal_id ?
              <Thumb
                {...bemClassesVote('icon', 'rewards img', 'icon checkbox__icon checkbox__icon_checkbox')}
                image={{ id: answer.medal_image }}
              /> :
              <span {...bemClassesVote('icon', 'rewards', 'icon checkbox__icon checkbox__icon_checkbox')} />
            }
            <span {...bemClassesVote('text', 'rewards', 'checkbox__text')} children={answer.answer} />
          </span>
        </div>
      );
    }

    if (allowActions) {
      checkBoxProps.value = myVoteStatus;
      checkBoxProps.disabled = true;
    }

    return (
      <Checkbox
        {...bemClassesVote('checkbox')}
        {...checkBoxProps}
        onChange={val => this.onAnswerChange(val, item.qid, answer.aid)}
        disableValidationState
        withIcon
        noError
        children={answer.answer}
      />
    );
  }

  // Show answer checkboxes, progressbar, all users who have voted and percentages
  renderUsersAndInfo(item = {}, userId, allowActions) {
    return (
      <table {...bemClassesVote('table', 'answer')}>
        <tbody>
          {map(item.answers, (answer, key) => {
            const myVoteStatus = this.checkMyVote(answer, userId, item);

            return (
              <tr key={`answer-${key}`} {...bemClassesVote('tr')}>
                <td
                  {...bemClassesVote('td', 'checkbox')}
                  children={this.showCheckbox(userId, item, myVoteStatus, answer, allowActions)}
                />
                <td
                  {...bemClassesVote('td', 'line')}
                  children={this.countVotes(answer.aid, item.counter)}
                />
                <td
                  {...bemClassesVote('td', 'count')}
                  children={this.countUsers(item.counter, item, answer)}
                />
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  needForumNick =()=> {
    this.setState({ needForumNick: true });
  }

  onCloseModalForumNick =()=> {
    this.setState({ needForumNick: false });
  }

  render() {
    const { i18n } = this;
    const { needForumNick } = this.state;
    const { className, data = [], auth: { id: userId, forum_nick } = {}, forumType = null } = this.props;

    return (
      map(data, (item, index) => {
        const allowActions = (
          !userId ||
          (item.counter && item.counter.users &&
            item.counter.users[item.qid] &&
            !item.settings.allow_change_answer) ||
          (item.forum_type === 'club' && !item.clubUserStatus)
        );
        const topicId = get(item, 'topic_id')

        return (
          <AccordionBlock
            {...bemClassesVote({ extra: className })}
            key={`question-${index}`}
            panelTopic=""
            dataView="viewBlockOnlyBtn"
            trackAs={forumType && `${forumType}Vote-${index}-${topicId}`}
            latestItemId={Math.max(...map(data, it => it.qid))}
          >
            <div {...bemClassesVote('content')}>
              <div {...bemClassesVote('title')}>
                <span {...bemClassesVote('text')} children={item.title} />
              </div>
              <div {...bemClassesVote('choices')}>
                {this.showMaxAnswersAmount(item)}
                {item.settings &&
                  <span
                    {...bemClassesVote('text')}
                    children={`${(item.settings && item.settings.allow_change_answer) ? i18n('can') : i18n('canT')} ${i18n('changeAnswer')} `}
                  />
                }
                {(item.counter && !!item.counter.count_all) &&
                  <span
                    {...bemClassesVote('text')}
                    children={`${i18n('countAnswer')} ${item.counter.count_all}.`}
                  />
                }
              </div>
              {this.renderUsersAndInfo(item, userId, allowActions)}
              <Row {...bemClassesVote('row', 'functional')} mpColumn>
                {!(!item.voteIsOpen || allowActions) && forum_nick &&
                  <Col {...bemClassesVote('col')} allPr={0}>
                    <Button
                      {...bemClassesVote('btn', 'vote')}
                      onClick={() => this.vote(item.qid, this.state.answers[item.qid])}
                      title={i18n('vote')}
                      label={i18n('vote')}
                    />
                  </Col>
                }
                {!(!item.voteIsOpen || allowActions) && !forum_nick &&
                  <Col {...bemClassesVote('col')} allPr={0}>
                    <Button
                      {...bemClassesVote('btn', 'vote')}
                      onClick={this.needForumNick}
                      title={i18n('vote')}
                      label={i18n('vote')}
                    />
                  </Col>
                }
                {needForumNick &&
                  <AddForumNick
                    onCloseModalForumNick={this.onCloseModalForumNick}
                  />
                }
                {!item.voteIsOpen &&
                  <Col {...bemClassesVote('col')} allPr={0}>
                    <span {...bemClassesVote('text')} children={i18n('votingClosed')} />
                  </Col>
                }
              </Row>
            </div>
          </AccordionBlock>
        );
      })
    );
  }
}
